import type { RxJsonSchema } from 'rxdb';
import type { ComponentRemovalCategories } from './componentRemovalCategories.types';

export const componentRemovalCategoriesSchema: RxJsonSchema<ComponentRemovalCategories> = {
  type: 'object',
  version: 0,
  description: 'describes component removal',
  primaryKey: 'name',
  properties: {
    pkComponentRemovalCategory: { type: 'number' },
    name: { type: 'string', maxLength: 36 },
    sort: { type: 'number' },
    isActive: { type: 'boolean' },
    dateModified: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
  },
};
